import fixture from './__fixtures__/mapPinTypes2.fixture.json'
import { parsePinTypeCatalogValue, type PinTypeEntry } from './pinTypeCatalog'

/**
 * A snapshot of production's `mapPinTypes2` Remote Config value, taken
 * 2026-09-16. It is a TEST FIXTURE and the prototype's data source. It is not
 * a runtime fallback: the app shows an empty catalog when Remote Config is
 * unreachable, exactly as mobile does, because a bundled copy is the kind of
 * drift this catalog exists to remove.
 *
 * `trap` was added by hand after `bait`, ahead of the matching Remote Config
 * publish, so the asset audits cover its artwork before the catalog lists it.
 * A regenerated snapshot keeps it once that publish has happened.
 *
 * Regenerate with `firebase remoteconfig:get --project natlink-production`
 * and extract `parameters.mapPinTypes2.defaultValue.value`.
 */
export const PIN_TYPE_CATALOG_FIXTURE: PinTypeEntry[] = parsePinTypeCatalogValue(fixture)
